import { parse } from 'cookie';

export default async function (context) {
    if (process.server) {
        const cookies = parse(context.req.headers.cookie || '') || {};

        const fetchUser = async function(user, token) {
            let { data } = await context.app.$folioApiRequest('userLoad', {
                userId: user,
                user: user,
                token: token,
            }, { authenticate: false });

            if (data.success) {
                return data.user;
            }

            throw "Invalid user ID or token";
        }
        
        if (cookies.user && cookies.token) {
            try {
                const user = await fetchUser(cookies.user, cookies.token);
                context.store.commit('auth/setUser', user);
            } catch (error) {
                console.log('Failed to fetch user: ' + error);
            }
        }
    }
}